import React, { useState, useEffect } from "react";
import axios from "axios";
import { useOutletContext, useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";

function Closed() {
  const [userData, setUserData] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        setGlobalLoading(true);
        const res = await axios.get(`${API_BASE_URL}/employeeinfos/joblist/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUserData(res.data.closed || []); // Use shelveds from API response
      } catch (err) {
        console.error("Error fetching data:", err);
        setUserData([]);
      } finally {
        setGlobalLoading(false);
      }
    };
    fetchEmployees();
  }, [API_BASE_URL, token, setGlobalLoading]);

  const columns = [
    { accessorKey: "job_id", header: "Job ID", size: 150 },
    { accessorKey: "department_name", header: "Department", size: 130 },
    { accessorKey: "designation", header: "Designation", size: 130 },
    { accessorKey: "role_type", header: "Role Type", size: 130 },
    { accessorKey: "worklocation", header: "Work Location", size: 130 },
    { accessorKey: "no_req", header: "Position Required", size: 130 },
    { accessorKey: "positions_filled", header: "Positions Filled", size: 130 },
    {
      accessorKey: "positions_remaining",
      header: "Positions Remaining",
      size: 130,
    },
    { accessorKey: "role_status_name", header: "Role Status", size: 130 },
    { accessorKey: "createdate", header: "Created", size: 130 },
    { accessorKey: "assigned_to", header: "Assigned To", size: 130 },
  ];

  return (
    <div className="content">
      <div className="card">
        <div className="card-header d-flex align-items-center flex-wrap gap-2">
          <h5 className="mb-0">Closed Jobs</h5>
        </div>

        <div className="card-body">
          {userData.length === 0 ? (
            <p className="text-muted">No closed jobs found.</p>
          ) : (
            <MaterialReactTable
              columns={columns}
              data={userData}
              enableColumnOrdering
              enableFilters
              initialState={{ pagination: { pageSize: 50 } }}
              muiTableBodyCellProps={{ sx: { padding: "8px 10px" } }}
              muiTableHeadCellProps={{
                sx: { backgroundColor: "#f5f5f5", fontWeight: "bold" },
              }}
              renderTopToolbarCustomActions={() => (
                <div className="d-flex gap-2 align-items-center ms-2">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => navigate("/employeeinfo/joblist")}
                  >
                    All Active Job Request
                  </button>
                </div>
              )}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Closed;
